module.exports = __webpack_public_path__ + "static/media/018-lebanon.32f1cb3f.svg";